export default __webpack_public_path__ + "static/275-9e0896e5737380ec0576298c53b46f85.gif";